export default __webpack_public_path__ + "static/media/complianceDummyIcon.77832482.svg";